import {
  DEFAULT_PAGE_TITLE,
  useRouterPageTitle,
} from "@/hooks/use-router-page-title";
import { Helmet } from "react-helmet-async";

/**
 * Overrides the browser page title with:
 * > [router title]: [page title] | Dash
 *
 * Example:
 * > Document: My Document Title | Dash
 *
 * Check RouterPageTitle for more information.
 */
export const BrowserPageTitle = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const routerTitle = useRouterPageTitle();

  return (
    <Helmet>
      <title>
        {routerTitle}: {children} | {DEFAULT_PAGE_TITLE}
      </title>
    </Helmet>
  );
};
